<template>
  <div id="app">
    <!-- <Header></Header> -->
    <router-view />
  </div>
</template>
<script>
// import Header from "@/components/Header.vue";
export default {
  components: {
    // Header,
  },
  created() {
    this.ceshi();
  },
  methods: {
    ceshi() {
      // 获取用户的User-Agent信息
      var userAgent = navigator.userAgent;

      // 判断是否为微信浏览器
      if (
        userAgent.indexOf("MicroMessenger") !== -1 ||
        userAgent.indexOf("WeChat") !== -1
      ) {
        // 是微信浏览器，可以进行相应的操作，例如重定向到其他页面或显示提示信息
        // window.location.href = "https://example.com/other-page";
        alert(
          "Por favor, utilice el navegador incluido en su teléfono para abrir！"
        );
        return;
      }
    },
  },
};
</script>

<style lang="less">
@import url(style/class.css);
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif, AppleSystemUIFont;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}
body {
  margin: 0;
  padding: 0;
}
@media screen and (min-width: 300px) and (max-width: 750px) {
  body {
    font-size: 12px;
  }
}
</style>
